import {
    MODIFYMERCHANT_SUCCESS,
    MODIFYMERCHANT_FAILED,
    RESET_MODIFYMERCHANT,
    LOADING_MODIFYMERCHANT,
    NETWORK_ERROR_MODIFYMERCHANT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetModifyMerchant = () => {
    return { type: RESET_MODIFYMERCHANT };
};

const modifyMerchant = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_MODIFYMERCHANT });
    await partnerServices
        .post("modifyAndAddList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(modifyMerchantsuccess(res.data));
                    break;
                default:
                    dispatch(modifyMerchantFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_MODIFYMERCHANT,
                payload: err
            });
        });
};
function modifyMerchantsuccess(data) {
    return {
        type: MODIFYMERCHANT_SUCCESS,
        payload: data
    };
}
function modifyMerchantFailed(data) {
    return {
        type: MODIFYMERCHANT_FAILED,
        payload: data
    };
}

export { resetModifyMerchant, modifyMerchant };
